// extracted by mini-css-extract-plugin
export default {"row":"row--rpmkX","row__information":"row__information--r_ps3","rowInformation":"row__information--r_ps3"};